import React, {useState, useEffect} from 'react';
import './StudentClassStudentAdminPage.css';
import apiClient from '../api/apiClient.js'
import {useAuth} from '../context/AuthContext'

export default function StudentClassStudentAdminPage(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [assignableStudents, setAssignableStudents] = useState([])
    const [studentClasses, setStudentClasses] = useState([])
    const [currentAssignableStudentClass, setCurrentAssignableStudentClass] = useState(null)
    const [currentAssignedStudentClass, setCurrentAssignedStudentClass] = useState(null)
    const [assignedStudents, setAssignedStudents] = useState([])
    const [dragOverActive, setDragOverActive] = useState(false)
    const [studentAssigned, setStudentAssigned] = useState(0)

    async function fetchStudentClasses(){
        try{
            const res = await apiClient.get('/api/studentclass/getall', {
                params:{schoolID: schoolID}
            })
            setStudentClasses(res.data)
        }catch(e){
            console.log("error in fetch student classes")
            console.log(e)
        }
    }
    async function fetchAssignableStudents(){
        try{
//            const res = await apiClient.get('/api/students/getall', {currentStudentClassID: currentStudentClass?.id})
              const res = await apiClient.get('/api/students/getassignedstudents', 
                {params: {currentStudentClassID: currentAssignableStudentClass?.id || null}} //if null get all unasigend students
              )
              setAssignableStudents(res.data)
        }catch(e){
            console.log("error in fetch Students")
            console.log(e)
        }
    }

    async function fetchAssignedStudents(){
        try{
            const res = await apiClient.get('/api/students/getassignedstudents', 
                {params: {currentStudentClassID: currentAssignedStudentClass?.id}})
            setAssignedStudents(res.data)

        }catch(e){
            console.log("error in fetching assigned students")
            console.log(e)
        }
    }


    useEffect(()=>{
        fetchStudentClasses()
        fetchAssignableStudents()
        fetchAssignedStudents()
    },[studentAssigned, currentAssignedStudentClass, currentAssignableStudentClass])

    function handleDragStart(e, student){
        e.dataTransfer.setData('studentId', student.id.toString())
    }

    function handleDragOver(e){
        e.preventDefault()
        setDragOverActive(true)
    }

    function handleDragLeave(){
        setDragOverActive(false)
    }

    async function handleDrop(e, studentClass){
        e.preventDefault()
        setDragOverActive(false)
        const studentId = parseInt(e.dataTransfer.getData('studentId'))
        await apiClient.post('/api/studentclass/assignstudent', {studentID: studentId, studentClassID: studentClass.id})
        setStudentAssigned(prev=>prev+1)
        /*
        const student = students.find(s => s.id === studentId)
        if (student && !assignedStudents.find(s => s.id === studentId)){
            setAssignedStudents(prev => [...prev, student])
        }*/
    }

    return(
        <div className="panel-container">
            <div className="panel">
                <select onChange={(e)=>{
                    setCurrentAssignableStudentClass(
                        studentClasses.find(s=> s.id === parseInt(e.target.value)))}}>       
                    <option key="0">Intet hold</option>
                    {studentClasses.map((studentClass) => (
                        <option key={studentClass.id} value={studentClass.id}>
                            {studentClass.holdnavn}</option>
                    ))}
                </select>
                <span>
                    <b>Holdnavn: </b>{currentAssignableStudentClass?.holdnavn}
                    <b>Holdtype: </b>{currentAssignableStudentClass?.studieretning}
                </span>

                <div
                    className={`drop-zone ${dragOverActive? 'drop-zone-active' : ''}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(e)=>handleDrop(e,currentAssignableStudentClass)}
                    >

                    {assignableStudents.lenght ===0 ?(
                        <p className="drop-zone-hint">Træk en kursist hertil</p>
                    ):
                    (
                        <table className="censor-table">
                            <thead>
                                <tr>
                                    <th style={{width: '35%'}}>Fornavn(e)</th>
                                    <th style={{width: '35%'}}>Efternavn</th>
                                    <th style={{width: '30%'}}>Studie</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignableStudents.map((s) => (
                                    <tr
                                        key={s.id}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, s)}
                                        className="draggable-row"
                                    >
                                        <td>{s.fornavne}</td>
                                        <td>{s.efternavn}</td>
                                        <td>{s.studie}</td>
                                    </tr>
                                ))}
                                {assignableStudents.length === 0 && (
                                    <tr>
                                        <td colSpan="3" style={{textAlign:'center', padding:'2rem', color:'#888'}}>
                                            Ingen kursister
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>           
            </div>

            <div className="panel">
                <select onChange={(e) => setCurrentAssignedStudentClass(studentClasses.find(sc => sc.id === parseInt(e.target.value)))}>
                    <option value="">Vælg hold...</option>
                    {studentClasses.map((studentClass) => (
                        <option key={studentClass.id} value={studentClass.id}>{studentClass.holdnavn}</option>
                    ))}
                </select>
                <span>
                    <b>Holdnavn: </b>{currentAssignedStudentClass?.holdnavn} <b>Holdtype: </b>{currentAssignedStudentClass?.studieretning}
                </span>

                <div
                    className={`drop-zone ${dragOverActive ? 'drop-zone-active' : ''}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={(e)=>handleDrop(e,currentAssignedStudentClass)}
                >
                    {assignedStudents.length === 0 ? (
                        <p className="drop-zone-hint">Træk en kursist hertil</p>
                    ) : (
                        <table className="censor-table">
                            <thead>
                                <tr>
                                    <th>Fornavn(e)</th>
                                    <th>Efternavn</th>
                                    <th>Studie</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignedStudents.map((s) => (
                                    <tr key={s.id}
                                        draggable
                                        onDragStart={(e)=> handleDragStart(e,s)}
                                        className="draggable-row"                                    
                                    >

                                        <td>{s.fornavne}</td>
                                        <td>{s.efternavn}</td>
                                        <td>{s.studie}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    )
}
